import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    audio: string;
    compressed: string;
    drawing: string;
    file: string;
    folder: string;
    image: string;
    interactive: string;
    interactiveLive: string;
    model: string;
    motion: string;
    pdf: string;
    project: string;
    spreadsheet: string;
    text: string;
    vector: string;
    video: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for the audio filetype */
            audio: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "getFileType.audio?c=11m5zcsxaqp30", defaultMessage: "Audio" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the compressed filetype */
            compressed: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "getFileType.compressed?c=1qj00k36d7rzd", defaultMessage: "Compressed" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the drawing filetype */
            drawing: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "getFileType.drawing?c=gv93tjv8unz5", defaultMessage: "Drawing" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the generic file filetype */
            file: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "getFileType.file?c=173vtkio1n12t", defaultMessage: "File" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for folder file type */
            folder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "getFileType.folder?c=f8z6h4z5qq8w", defaultMessage: "Folder" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the image filetype */
            image: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "getFileType.image?c=3aqii3nj3sgzb", defaultMessage: "Image" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the interactive filetype */
            interactive: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "getFileType.interactive?c=tmf76ocgxscc", defaultMessage: "Interactive" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the interactive live filetype */
            interactiveLive: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "getFileType.interactiveLive?c=nxnlpqdqfotg", defaultMessage: "Web URL" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the 3D model filetype */
            model: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "getFileType.model?c=1uckamxqfqgey", defaultMessage: "Model" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the motion filetype */
            motion: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "getFileType.motion?c=2g38e3q7zhy2z", defaultMessage: "Motion" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the pdf filetype */
            pdf: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "getFileType.pdf?c=1spvtoode4pkt", defaultMessage: "PDF" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the project filetype */
            project: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "getFileType.project?c=1y2semxo3c9fl", defaultMessage: "Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the spreadsheet filetype */
            spreadsheet: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "getFileType.spreadsheet?c=64mrbdpdsmfx", defaultMessage: "Spreadsheet" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the text filetype */
            text: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "getFileType.text?c=12toypt6n8yru", defaultMessage: "Text" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the vector filetype */
            vector: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "getFileType.vector?c=2zrjvnbec9yqx", defaultMessage: "Vector" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the video filetype */
            video: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "getFileType.video?c=1xjb9ggnb6xim", defaultMessage: "Video" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
